
import ReviewModalContent from "./ReviewModalContent.vue";
import ReviewModalGallery from "./ReviewModalGallery.vue";
import SimplePopup from "~/components/popups/SimplePopup.vue";
import CloseSvgBold from "~/components/svg/CloseSvgBold.vue";

export default {
  name: "ReviewModal",
  components: {
    SimplePopup,
    CloseSvgBold,
    ReviewModalGallery,
    ReviewModalContent,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    review: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    mediaList: {
      type: Array,
      default: () => [],
    },
  },
};
